import * as Yup from "yup";

export const defaultValues = { notificationUrl: "" };

/** Validates the HTTP(S) endpoint used for brand payment notifications. */
export const schema = Yup.object().shape({
  notificationUrl: Yup.string()
    .trim()
    .required("Webhook URL is required")
    .url("Enter a valid HTTP or HTTPS URL")
    .matches(/^https?:\/\//i, {
      message: "Enter a valid HTTP or HTTPS URL",
      excludeEmptyString: true,
    }),
});
